module.exports = "<mat-slide-toggle></mat-slide-toggle>\r\n"